export enum CookieType {
  None = "none",
  Required = "required_cookies",
  Functional = "functional_cookies",
}
